var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"communication"},[_c('Parle',{attrs:{"root":"https://parle.solidcommunity.net/public/"}}),_c('InboxView'),_c('Chat')],1)}
var staticRenderFns = []

export { render, staticRenderFns }